<p>view-device works!</p>
